/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductByLegacyIdQueryResponse,
  FindProductByLegacyIdPathParams,
  FindProductByLegacyId404,
} from "../types/FindProductByLegacyId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductByLegacyIdQueryKey = (
  legacyId: FindProductByLegacyIdPathParams["legacyId"] | undefined
) =>
  [
    { url: "/v1/product/legacy/:legacyId", params: { legacyId: legacyId } },
  ] as const

export type FindProductByLegacyIdQueryKey = ReturnType<
  typeof findProductByLegacyIdQueryKey
>

/**
 * @description Backward compatibility endpoint to find a product's UUID using its legacy integer ID
 * @summary Find product UUID by legacy integer ID
 * {@link /v1/product/legacy/:legacyId}
 */
export async function findProductByLegacyId(
  legacyId: FindProductByLegacyIdPathParams["legacyId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductByLegacyIdQueryResponse,
    ResponseErrorConfig<FindProductByLegacyId404>,
    unknown
  >({ method: "GET", url: `/v1/product/legacy/${legacyId}`, ...requestConfig })
  return res
}

export function findProductByLegacyIdQueryOptions(
  legacyId: FindProductByLegacyIdPathParams["legacyId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductByLegacyIdQueryKey(legacyId)
  return queryOptions<
    ResponseConfig<FindProductByLegacyIdQueryResponse>,
    ResponseErrorConfig<FindProductByLegacyId404>,
    ResponseConfig<FindProductByLegacyIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!legacyId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductByLegacyId(legacyId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Backward compatibility endpoint to find a product's UUID using its legacy integer ID
 * @summary Find product UUID by legacy integer ID
 * {@link /v1/product/legacy/:legacyId}
 */
export function useFindProductByLegacyId<
  TData = ResponseConfig<FindProductByLegacyIdQueryResponse>,
  TQueryData = ResponseConfig<FindProductByLegacyIdQueryResponse>,
  TQueryKey extends QueryKey = FindProductByLegacyIdQueryKey,
>(
  legacyId: FindProductByLegacyIdPathParams["legacyId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductByLegacyIdQueryResponse>,
        ResponseErrorConfig<FindProductByLegacyId404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductByLegacyIdQueryKey(legacyId)

  const query = useQuery(
    {
      ...findProductByLegacyIdQueryOptions(legacyId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<FindProductByLegacyId404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
